import React from 'react'
import logo from '../../../assets/static/logo-unesul.png'

const LogotipoUnesul = () => (
	<img className="logotipo-unesul" src={logo} alt="Logotipo Unesul" />
)

export default LogotipoUnesul
